export default {
  list: {
    title: 'Término',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  table: {
    title: 'Juegos Término Activos',
    searchPlaceholder: 'Buscar por algo...',
    letterFilter: 'N.º de letras',
    columns: {
      letters: 'N.º Letras',
      word: 'Palabra',
      publishedDate: 'Fecha de publicación',
    },
  },
  form: {
    title: {
      create: 'Nuevo término',
      edit: 'Editar término',
    },
    name: {
      label: 'Nombre:',
      invalid: 'El nombre es obligatorio',
    },
    letter: {
      label: 'Cant. Letras:',
    },
    publishedDate: {
      label: 'Publicación:',
    },
    word: {
      label: 'Palabra:',
      placeholder: 'Escriba la palabra',
      invalid: 'La palabra es obligatoria',
    },
    attempt: {
      label: 'Intentos:',
      invalid: 'Los intentos son obligatorios',
    },
  },
  delete: {
    title: 'Confirme la exclusión del juego',
    message: '¿Está seguro de que desea eliminar este juego?',
  },
  alert: {
    deleted: 'Juego eliminado con éxito',
  },
};
